import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import PostCard from 'components/PostCard'
import { Skeleton } from '@mui/material'
import sx from './styles'

const PostsList = ({
  title,
  description,
  variantTitle = 'h1',
  componentTitle = 'h1',
  items,
  loading,
  // error,
}) => {
  const skeletonLoading = (
    [0, 1, 2, 3].map((item) => (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        xl={2}
        key={`skeleton-${item?.slug}`}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height={60}
        />
        <Skeleton
          variant="text"
          sx={{ fontSize: '1rem' }}
        />
      </Grid>
    ))
  )

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
        >
          <Box>
            <Typography
              variant={variantTitle}
              component={componentTitle}
            >
              <FormattedMessage id={title} />
            </Typography>
          </Box>

          {description && (
            <Box mt={2}>
              <Typography variant="body1">
                <FormattedMessage id={description} />
              </Typography>
            </Box>
          )}

        </Grid>
        <Grid
          mt={2}
          item
          xs={12}
          container
          spacing={2}
        >
          {loading && (
            skeletonLoading
          )}
          {items?.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={2}
              key={`post-${item?.slug}`}
            >
              <PostCard
                item={item}
                key={`activity-${item?.id}`}
                sx={sx.activityCard}
              />
            </Grid>
          ))}
          {items?.length === 0 && (
            <Grid
              item
              xs={12}
              textAlign="center"
            >
              <Typography variant="subttile1">
                <FormattedMessage id="BLOG_NO_ENTRIES" />
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default memo(PostsList)
